import { authServerProxyUrl, fileStorageProxyUrl } from 'api_urls';
// WIP
// Use this url for local file service
// const fileStorageProxyUrl = 'httpl://localhost:5010';

export const URLS = {
  interactPrivateStorage: `${authServerProxyUrl}/api/storage/self-serve-private`,
  fileServerStorage: `${fileStorageProxyUrl}/api/file-server`,
};
